export const MONTHS_PER_YEAR = 12;

export const MONTHLY_SEAT_PRICE_PER_PERIOD = 2.4;
export const ANNUAL_SEAT_PRICE_PER_PERIOD = 24;

export const MONTHLY_SEAT_PRICE_PER_MONTH = MONTHLY_SEAT_PRICE_PER_PERIOD;
export const ANNUAL_SEAT_PRICE_PER_MONTH = ANNUAL_SEAT_PRICE_PER_PERIOD / MONTHS_PER_YEAR;

// Marketing quotas quoted in upgrade surfaces. They mirror the backend configuration
// (UploadLimitsOptions / License.MaxUploadPerMonthInGb) - keep in sync if limits change.
export const FREE_MONTHLY_QUOTA_GB = 3;
export const PRO_MONTHLY_QUOTA_GB_PER_SEAT = 50;
